import { z } from 'zod';
import { CurrencyDTO } from '@/queries/types/Currency.types';

const FastShopLowBalanceBaseSchema = z.object({
  userId: z.string().min(1),
  gameId: z.string().min(1),
  sessionId: z.string().min(1),
  roundId: z.string().min(1),
  currency: CurrencyDTO,
}).passthrough();

export const FastShopRoundLowBalanceContextSchema = FastShopLowBalanceBaseSchema.extend({
  totalBetAmount: z.number(),
  primaryBalance: z.number(),
  bonusBalance: z.number(),
});

export const FastShopSessionLowBalanceContextSchema = FastShopLowBalanceBaseSchema.extend({
  balanceAtSessionStart: z.number(),
  bonusBalanceAtSessionStart: z.number(),
  currentPrimaryBalance: z.number(),
  currentBonusBalance: z.number(),
  threshold: z.number(),
});

export type FastShopRoundLowBalanceContext = z.infer<typeof FastShopRoundLowBalanceContextSchema>;
export type FastShopSessionLowBalanceContext = z.infer<typeof FastShopSessionLowBalanceContextSchema>;
export type FastShopLowBalanceTriggerSource = 'round' | 'session';
export type FastShopLowBalanceTriggerPayload
  = | FastShopRoundLowBalanceContext
    | FastShopSessionLowBalanceContext;
export type FastShopRoundLowBalanceTrigger = FastShopRoundLowBalanceContext & { source: 'round' };
export type FastShopSessionLowBalanceTrigger = FastShopSessionLowBalanceContext & { source: 'session' };
export type FastShopLowBalanceTrigger
  = | FastShopRoundLowBalanceTrigger
    | FastShopSessionLowBalanceTrigger;
